/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetorgstaleaccountsMicrosoftStaleAccount
 */
export interface JumboGetorgstaleaccountsMicrosoftStaleAccount {
    /**
     * 
     * @type {string}
     * @memberof JumboGetorgstaleaccountsMicrosoftStaleAccount
     */
    loggedInAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JumboGetorgstaleaccountsMicrosoftStaleAccount
     */
    updateAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JumboGetorgstaleaccountsMicrosoftStaleAccount
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetorgstaleaccountsMicrosoftStaleAccount
     */
    userId?: string;
}

/**
 * Check if a given object implements the JumboGetorgstaleaccountsMicrosoftStaleAccount interface.
 */
export function instanceOfJumboGetorgstaleaccountsMicrosoftStaleAccount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetorgstaleaccountsMicrosoftStaleAccountFromJSON(json: any): JumboGetorgstaleaccountsMicrosoftStaleAccount {
    return JumboGetorgstaleaccountsMicrosoftStaleAccountFromJSONTyped(json, false);
}

export function JumboGetorgstaleaccountsMicrosoftStaleAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetorgstaleaccountsMicrosoftStaleAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loggedInAt': !exists(json, 'loggedInAt') ? undefined : json['loggedInAt'],
        'updateAt': !exists(json, 'updateAt') ? undefined : json['updateAt'],
        'userEmail': !exists(json, 'userEmail') ? undefined : json['userEmail'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JumboGetorgstaleaccountsMicrosoftStaleAccountToJSON(value?: JumboGetorgstaleaccountsMicrosoftStaleAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loggedInAt': value.loggedInAt,
        'updateAt': value.updateAt,
        'userEmail': value.userEmail,
        'userId': value.userId,
    };
}

